import API_CONSTANT from 'constants/apiConstant';
import { put, takeEvery } from 'redux-saga/effects';
import { triggerSendReferralsApiCallSuccess } from 'redux/actions';
import { TRIGGER_SEND_REFERRALS_API_CALL } from 'redux/actionTypes';
import { apiCall } from 'services';
import { ChangeHistory } from 'utils';

function* triggerSendReferralsApiCall(actions) {
	const { data, callback, stopLoader } = actions;
	const api = yield apiCall({
		urlType: API_CONSTANT.URL_TYPE.POST_PE_V1,
		url: API_CONSTANT.URL.SEND_REFERRALS,
		method: 'POST',
		data,
		options: {
			defaultLoader: !stopLoader,
		},
	});
	if (api && api.data.statusCode === '200') {
		const apiData = api.data.data;
		callback && callback(apiData);
		yield put(triggerSendReferralsApiCallSuccess(apiData));
		ChangeHistory('push', '/referral-contact-list');
	}
}

export default function* triggerSendReferralsApiCallSaga() {
	yield takeEvery(TRIGGER_SEND_REFERRALS_API_CALL, triggerSendReferralsApiCall);
}
